/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '../../../../theme/css/auth.css.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/common';
import * as i3 from '@angular/router';
import * as i4 from '../../../../../app/components/auth/authLayout/authLayout.component';
const styles_AuthLayoutComponent:any[] = [i0.styles];
export const RenderType_AuthLayoutComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_AuthLayoutComponent,data:{}});
function View_AuthLayoutComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'div',[['class',
      'spinner-circle']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          3,':svg:svg',[['class','spinner-circular'],['viewBox','25 25 50 50']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          [' '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),0,':svg:circle',[['class',
          'path'],['cx','50'],['cy','50'],['fill','none'],['r','20'],['stroke-miterlimit',
          '10'],['stroke-width','2']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵted((null as any),
          [' ']))],(null as any),(null as any));
}
export function View_AuthLayoutComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),12,'div',[['class',
      'wrapper wrapper-full-page']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),9,'div',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),i1.ɵdid(278528,(null as any),0,i2.NgClass,[i1.IterableDiffers,
      i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i1.ɵpod({'main-panel':0}),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵeld(16777216,
          (null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(212992,
          (null as any),0,i3.RouterOutlet,[i3.ChildrenOutletContexts,i1.ViewContainerRef,
              i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_AuthLayoutComponent_1)),
      i1.ɵdid(16384,(null as any),0,i2.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),[' '])),(_l()(),i1.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    var _co:i4.AuthLayoutComponent = _v.component;
    const currVal_0:any = _ck(_v,4,0,_co.isMobileMenu);
    _ck(_v,3,0,currVal_0);
    _ck(_v,7,0);
    const currVal_1:any = _co.loading;
    _ck(_v,10,0,currVal_1);
  },(null as any));
}
export function View_AuthLayoutComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'auth-layout',
      ([] as any[]),(null as any),[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onResize($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_AuthLayoutComponent_0,RenderType_AuthLayoutComponent)),i1.ɵdid(4308992,
      (null as any),0,i4.AuthLayoutComponent,[i1.ElementRef,i3.Router,i1.Renderer2],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AuthLayoutComponentNgFactory:i1.ComponentFactory<i4.AuthLayoutComponent> = i1.ɵccf('auth-layout',
    i4.AuthLayoutComponent,View_AuthLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9hdXRoTGF5b3V0L2F1dGhMYXlvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2F1dGgvYXV0aExheW91dC9hdXRoTGF5b3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2F1dGgvYXV0aExheW91dC9hdXRoTGF5b3V0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXV0aC9hdXRoTGF5b3V0L2F1dGhMYXlvdXQuY29tcG9uZW50LnRzLkF1dGhMYXlvdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwid3JhcHBlciB3cmFwcGVyLWZ1bGwtcGFnZVwiPiA8ZGl2IFtuZ0NsYXNzXT1cInsnbWFpbi1wYW5lbCc6IGlzTW9iaWxlTWVudX1cIj4gPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PiA8ZGl2IGNsYXNzPVwic3Bpbm5lci1jaXJjbGVcIiAqbmdJZj1cImxvYWRpbmdcIj4gPHN2ZyBjbGFzcz1cInNwaW5uZXItY2lyY3VsYXJcIiB2aWV3Qm94PVwiMjUgMjUgNTAgNTBcIj4gPGNpcmNsZSBjbGFzcz1cInBhdGhcIiBjeD1cIjUwXCIgY3k9XCI1MFwiIHI9XCIyMFwiIGZpbGw9XCJub25lXCIgc3Ryb2tlLXdpZHRoPVwiMlwiIHN0cm9rZS1taXRlcmxpbWl0PVwiMTBcIj48L2NpcmNsZT4gPC9zdmc+IDwvZGl2PiA8L2Rpdj4gPC9kaXY+IiwiPGF1dGgtbGF5b3V0PjwvYXV0aC1sYXlvdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQXVIO01BQUE7TUFBNEMsc0NBQUM7VUFBQTtVQUFBLDBEQUFvRDtVQUFBLFFBQUM7VUFBQTtVQUFBO1VBQUEsZ0JBQXlHLHNDQUFPO1VBQUE7OztvQkFBelU7TUFBQTtNQUFBLGdCQUF1QyxzQ0FBQztNQUFBO01BQUEscUNBQUE7a0RBQUE7YUFBSyxtQkFBeUMsc0NBQUM7VUFBQTtVQUFBLGlFQUFBO1VBQUE7MENBQUE7VUFBQSw2QkFBK0Isc0NBQUM7aUJBQUE7YUFBQTtVQUFBLHdCQUF5TixzQ0FBTztVQUFBOztJQUExUztJQUFMLFdBQUssU0FBTDtJQUErQztJQUE0RDtJQUE1QixZQUE0QixTQUE1Qjs7OztvQkNBdkg7TUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBQTtNQUFBLHFFQUFBO01BQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./compiled/app/components/auth/authLayout/authLayout.component.ngfactory.ts